import classNames from "classnames";
import { Typography } from "PFComponents/typography";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "./quote.module.scss";

type QuoteProps = {
  notificationsOpened?: boolean;
  className?: string;
};

export const Quote = ({ notificationsOpened = false, className }: QuoteProps): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard" });

  return (
    <div className={classNames(css.root, className)}>
      <Typography
        variant="bodyRegular"
        className={classNames(css.quote, { [css.notificationsOpened]: notificationsOpened })}
      >
        {t("quote")}
      </Typography>
      <Typography variant="bodyRegular" className={css.author}>
        H. Jackson Brown Jr
      </Typography>
    </div>
  );
};
